<template>
  <svg :width="width" :height="height" viewBox="0 0 54 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="22.5391" y="14" width="11.1524" height="26" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M32.672 5.196C32.1588 4.23767 31.354 3.42885 30.3505 2.86275C29.347 2.29664 28.1855 1.99628 26.9999 1.99628C25.8143 1.99628 24.6528 2.29664 23.6493 2.86275C22.6457 3.42885 21.841 4.23767 21.3278 5.196L3.22516 37.126C1.05936 40.938 3.79616 46 8.89505 46H45.1025C50.2036 46 52.9359 40.94 50.7746 37.126L32.672 5.196ZM26.9999 16C27.5914 16 28.1588 16.2107 28.5771 16.5858C28.9954 16.9609 29.2304 17.4696 29.2304 18V28C29.2304 28.5304 28.9954 29.0391 28.5771 29.4142C28.1588 29.7893 27.5914 30 26.9999 30C26.4083 30 25.841 29.7893 25.4227 29.4142C25.0044 29.0391 24.7694 28.5304 24.7694 28V18C24.7694 17.4696 25.0044 16.9609 25.4227 16.5858C25.841 16.2107 26.4083 16 26.9999 16ZM26.9999 33C27.5914 33 28.1588 33.2107 28.5771 33.5858C28.9954 33.9609 29.2304 34.4696 29.2304 35V36C29.2304 36.5304 28.9954 37.0391 28.5771 37.4142C28.1588 37.7893 27.5914 38 26.9999 38C26.4083 38 25.841 37.7893 25.4227 37.4142C25.0044 37.0391 24.7694 36.5304 24.7694 36V35C24.7694 34.4696 25.0044 33.9609 25.4227 33.5858C25.841 33.2107 26.4083 33 26.9999 33Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 54
    },
    height: {
      type: Number,
      default: 48
    },
    fill: {
      type: String,
      default: '#F2A516'
    }
  }
}
</script>